import { API_BASE } from '../../services/api';

export type ProCaseStatus = 'draft' | 'in_review' | 'completed' | 'archived';

export interface ProCase {
    id: string;
    owner_user_id: string;
    estate_id: string | null;
    client_name: string | null;
    deceased_name: string | null;
    executor_name: string | null;
    matter_reference: string | null;
    status: ProCaseStatus;
    created_at: string;
    updated_at: string;
}

const headers = { 'Content-Type': 'application/json' };

export const proCaseApi = {
    async list(): Promise<ProCase[]> {
        const r = await fetch(`${API_BASE}/api/pro/cases`, { credentials: 'include' });
        if (!r.ok) throw new Error('Failed to load cases');
        return r.json();
    },
    async get(id: string): Promise<ProCase> {
        const r = await fetch(`${API_BASE}/api/pro/cases/${id}`, { credentials: 'include' });
        if (!r.ok) throw new Error('Case not found');
        return r.json();
    },
    async create(input: {
        client_name?: string;
        deceased_name?: string;
        executor_name?: string;
        matter_reference?: string;
    }): Promise<ProCase> {
        const r = await fetch(`${API_BASE}/api/pro/cases`, {
            method: 'POST',
            credentials: 'include',
            headers,
            body: JSON.stringify(input),
        });
        if (!r.ok) throw new Error('Failed to create case');
        return r.json();
    },
    async update(id: string, input: Partial<Omit<ProCase, 'id' | 'owner_user_id' | 'estate_id' | 'created_at' | 'updated_at'>>): Promise<ProCase> {
        const r = await fetch(`${API_BASE}/api/pro/cases/${id}`, {
            method: 'PATCH',
            credentials: 'include',
            headers,
            body: JSON.stringify(input),
        });
        if (!r.ok) throw new Error('Failed to update case');
        return r.json();
    },
    /**
     * Idempotent: ensures the case has an estate row bound for audit data.
     * Returns the estate_id (the wizard then loads/saves via /api/estates/:id).
     */
    async startAudit(id: string): Promise<{ estate_id: string; case_id: string }> {
        const r = await fetch(`${API_BASE}/api/pro/cases/${id}/audit`, {
            method: 'POST',
            credentials: 'include',
            headers,
        });
        if (!r.ok) throw new Error('Failed to start audit');
        return r.json();
    },
};
